import React from 'react'
import Logo from '../header/logo'
import Menu from '../header/menu'

const header = () => {
    return (
        <div className='bg-black w-full h-fit flex justify-between items-center px-5 py-3'>
            <Logo />
            <Menu />
        </div>

    )
}

export default header